export default __webpack_public_path__ + "static/media/lines_logo.045fafb3.svg";